import axios from 'axios';

//GET_FILE
export const getFile = async (folderName, fileName, apitoken) => {
    try {
        const response = await axios.post(
            'https://adapt-flask-ep.com/adapt/fs.php',
            {
                serviceName: 'GET_FILE',
                folderName: folderName,
                fileName: fileName,
                IDD: apitoken._id,
                Token: '000111', // Token fisso
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(`Errore durante il recupero del file: ${error.message}`);
    }
};

//GET_FILE_VIZIT
export const getFileVizit = async (folderName, fileName, apitoken) => {
    try {
        const response = await axios.post(
            'https://vizitfs.softmining.it/fs.php',
            {
                serviceName: 'GET_FILE',
                folderName: folderName,
                fileName: fileName,
                IDD: apitoken._id,
                Token: '000111', // Token fisso
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(`Errore durante il recupero del file: ${error.message}`);
    }
};

export const getFilePDB = async (folderName, fileName, apitoken) => {
    try {
        const response = await axios.post(
            'https://cleanpdb.softmining.it/fs.php',
            {
                serviceName: 'GET_FILE',
                folderName: folderName,
                fileName: fileName,
                IDD: apitoken._id,
                Token: '000111', // Token fisso
            }
        );
        console.log("prova");
        console.log(response.data);
        return response.data;
    } catch (error) {
        throw new Error(`Errore durante il recupero del file: ${error.message}`);
    }
};

//GET_FILE_DEEP
export const getFileDeep = async (folderName, fileName, apitoken) => {
    try {
        const response = await axios.post(
            'https://deep-sage.softmining.it/fs.php',
            {
                serviceName: 'GET_FILE',
                folderName: folderName,
                fileName: fileName,
                IDD: apitoken._id,
                Token: '000111', // Token fisso
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(`Errore durante il recupero del file: ${error.message}`);
    }
};

//GET_FILES
export const getFiles = async (apitoken, folderName) => {
    try {
        const response = await axios.post(
            'https://cleanpdb.softmining.it/fs.php',
            {
                serviceName: 'GET_FILES',
                folderName: folderName,
                IDD: apitoken,
                Token: '000111', // Token fisso
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(`Errore durante il recupero dei file: ${error.message}`);
    }
};

//GET_FILES_VIZIT
export const getFilesVizit = async (apitoken, folderName) => {
    try {
        const response = await axios.post(
            'https://vizitfs.softmining.it/fs.php',
            {
                serviceName: 'GET_FILES',
                folderName: folderName,
                IDD: apitoken,
                Token: '000111', // Token fisso
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(`Errore durante il recupero dei file: ${error.message}`);
    }
};


//GET_FILESDEEP
export const getFilesDeep = async (apitoken, folderName) => {
    try {
        const response = await axios.post(
            'https://deep-sage.softmining.it/fs.php',
            {
                serviceName: 'GET_FILES',
                folderName: folderName,
                IDD: apitoken,
                Token: '000111', // Token fisso
            }
        );
        console.log(response.data);
        return response.data;
    } catch (error) {
        throw new Error(`Errore durante il recupero dei file: ${error.message}`);
    }
};

//DELETE_FILE
export const deleteFiles = async (apitoken, folderName, fileName) => {
    try {
        const response = await axios.post(
            'https://deep-sage.softmining.it/fs.php',
            {
                serviceName: 'DELETE_FILE',
                folderName: folderName,
                IDD: apitoken,
                Token: '000111', // Token fisso
                fileName: fileName
            }
        );
        console.log(response.data);
        return response.data;
    } catch (error) {
        throw new Error(`Errore durante il recupero dei file: ${error.message}`);
    }
};

//DELETE_FILE_VIZIT
export const deleteFilesVizit = async (apitoken, folderName, fileName) => {
    try {
        const response = await axios.post(
            'https://vizitfs.softmining.it/fs.php',
            {
                serviceName: 'DELETE_FILE',
                folderName: folderName,
                IDD: apitoken,
                Token: '000111', // Token fisso
                fileName: fileName
            }
        );
        console.log(response.data);
        return response.data;
    } catch (error) {
        throw new Error(`Errore durante il recupero dei file: ${error.message}`);
    }
};

//DELETE_FILE_PDB
export const deleteFilesPDB = async (apitoken, folderName, fileName) => {
    try {
        const response = await axios.post(
            'https://cleanpdb.softmining.it/fs.php',
            {
                serviceName: 'DELETE_FILE',
                folderName: folderName,
                IDD: apitoken,
                Token: '000111', // Token fisso
                fileName: fileName
            }
        );
        console.log(response.data);
        return response.data;
    } catch (error) {
        throw new Error(`Errore durante il recupero dei file: ${error.message}`);
    }
};


//RENAME_FILE
export const renameFiles = async (apitoken, folderName, fileName, newFileName) => {
    try {
        const response = await axios.post(
            'https://deep-sage.softmining.it/fs.php',
            {
                serviceName: 'RENAME_FILE',
                folderName: folderName,
                IDD: apitoken,
                Token: '000111', // Token fisso
                fileName: fileName,
                newFileName: newFileName
            }
        );
        console.log(response.data);
        return response.data;
    } catch (error) {
        throw new Error(`Errore durante il recupero dei file: ${error.message}`);
    }
};

//RENAME_FILE_VIZIT
export const renameFilesVizit = async (apitoken, folderName, fileName, newFileName) => {
    try {
        const response = await axios.post(
            'https://vizitfs.softmining.it/fs.php',
            {
                serviceName: 'RENAME_FILE',
                folderName: folderName,
                IDD: apitoken,
                Token: '000111', // Token fisso
                fileName: fileName,
                newFileName: newFileName
            }
        );
        console.log(response.data);
        return response.data;
    } catch (error) {
        throw new Error(`Errore durante il recupero dei file: ${error.message}`);
    }
};

//RENAME_FILE_PDB
export const renameFilesPDB = async (apitoken, folderName, fileName, newFileName) => {
    try {
        const response = await axios.post(
            'https://cleanpdb.softmining.it/fs.php',
            {
                serviceName: 'RENAME_FILE',
                folderName: folderName,
                IDD: apitoken,
                Token: '000111', // Token fisso
                fileName: fileName,
                newFileName: newFileName
            }
        );
        console.log(response.data);
        return response.data;
    } catch (error) {
        throw new Error(`Errore durante il recupero dei file: ${error.message}`);
    }
};